if (window.matchMedia('(max-width: 1024px)').matches) {
  //スマホ処理
  var w = document.body.clientWidth * 3;
  // var h = document.documentElement.clientHeight * 1.2;
  var h = 1000;
} else if (window.matchMedia('(min-width:1025px)').matches) {
  //PC処理
  // var w = document.body.clientWidth;
  // var h = document.documentElement.clientHeight * 0.8;
  var w = 2000;
  var h = 2000;
}
  console.log(w);
  console.log(h);

// トップページコンセプトセクション
if (document.getElementById('concept__box__gradation') != null) {

  // PIXI.オブジェクト生成
  let app = new PIXI.Application({
    width: w,
    height: h,
    transparent: true,//背景透明化
  });
  document.getElementById('concept__box__gradation').appendChild(app.view);

  let count = 0;

  const ropeLength = 300;
  
  const points = [];

  for (let i = 0; i < 100; i++) {
    points.push(new PIXI.Point(i * ropeLength, 0));
  }

  const strip = new PIXI.SimpleRope(PIXI.Texture.from('https://cdn.shopify.com/s/files/1/0553/5527/7414/files/gradation.png?v=1665543664'), points);

  strip.x = -459;

  const snakeContainer = new PIXI.Container();
  snakeContainer.x = 100;
  snakeContainer.y = 490;

  if (window.matchMedia('(max-width: 1024px)').matches) {
    //スマホ処理
    snakeContainer.x = 10;
    snakeContainer.y = 520;
  }

  
  // snakeContainer.scale.set(800 / 1100);
  app.stage.addChild(snakeContainer);

  snakeContainer.addChild(strip);

  app.ticker.add(() => {
    count += 0.01;

    // make the snake
    for (let i = 0; i < points.length; i++) {
      points[i].y = Math.cos((i * 0.8) + count) * 100;
      points[i].x = i * ropeLength + Math.cos((i * 0.4) + count) * 100;
    }
  });

}


// コンセプトページ
if (document.getElementById('conceptFixed__gradation') != null) {

if (window.matchMedia('(max-width: 1024px)').matches) {
  //スマホ処理
  var fw = document.body.clientWidth * 3;
  var fh = 1000;
} else if (window.matchMedia('(min-width:1025px)').matches) {
  //PC処理
  var fw = 3000;
  var fh = 3000;
}
  
  // PIXI.オブジェクト生成
  let app = new PIXI.Application({
    width: fw,
    height: fh,
    transparent: true,//背景透明化
  });
  document.getElementById('conceptFixed__gradation').appendChild(app.view);

  let count = 0;

  const ropeLength = 300;
  const points = [];

  for (let i = 0; i < 100; i++) {
    points.push(new PIXI.Point(i * ropeLength, 0));
  }

  const strip = new PIXI.SimpleRope(PIXI.Texture.from('https://cdn.shopify.com/s/files/1/0553/5527/7414/files/gradation.png?v=1665543664'), points);

  strip.x = -459;

  const snakeContainer = new PIXI.Container();
  snakeContainer.x = 100;
  snakeContainer.y = 500;

  if (window.matchMedia('(max-width: 1024px)').matches) {
    //スマホ処理
    snakeContainer.x = 10;
    snakeContainer.y = 530;
  }

  // snakeContainer.scale.set(800 / 1100);
  app.stage.addChild(snakeContainer);

  snakeContainer.addChild(strip);

  app.ticker.add(() => {

    count += 0.01;
    // make the snake
    for (let i = 0; i < points.length; i++) {
      points[i].y = Math.sin((i * 0.8) + count) * 100;
      points[i].x = i * ropeLength + Math.cos((i * 0.8) + count) * 100;
    }

    if (window.matchMedia('(max-width: 1024px)').matches) {
      count += 0.006;
      // make the snake
      for (let i = 0; i < points.length; i++) {
        points[i].y = Math.sin((i * 0.8) + count) * 80;
        points[i].x = i * ropeLength + Math.cos((i * 0.8) + count) * 10;
      }
    }
  
  });

}



// 横長
if (window.matchMedia('(max-width: 1024px)').matches) {
  //スマホ処理
  var wSP = document.body.clientWidth * 3;
  // var hSP = document.documentElement.clientHeight * 1.2;
  var hSP = 1000;
} else if (window.matchMedia('(min-width:1025px)').matches) {
  //PC処理
  var wSP = 2000;
  var hSP = 2000;
}

// フッター
if (document.getElementById('footer__box__gradation') != null) {

  // PIXI.オブジェクト生成
  let app = new PIXI.Application({
    width: wSP,
    height: hSP,
    transparent: true,//背景透明化
  });
  document.getElementById('footer__box__gradation').appendChild(app.view);

  let count = 0;

  const ropeLength = 90;
  const points = [];

  for (let i = 0; i < 100; i++) {
    points.push(new PIXI.Point(i * ropeLength, 0));
  }

  const strip = new PIXI.SimpleRope(PIXI.Texture.from('https://cdn.shopify.com/s/files/1/0553/5527/7414/files/gradation.png?v=1665543664'), points);

  strip.x = -459;
  
  const snakeContainer = new PIXI.Container();
  snakeContainer.x = 100;
  snakeContainer.y = 400;

  if (window.matchMedia('(max-width: 1024px)').matches) {
    //スマホ処理
    snakeContainer.x = 100;
    snakeContainer.y = 430;
  }

  
  // snakeContainer.scale.set(800 / 1100);
  app.stage.addChild(snakeContainer);

  snakeContainer.addChild(strip);

  app.ticker.add(() => {
    count += 0.01;

    // make the snake
    for (let i = 0; i < points.length; i++) {
      points[i].y = Math.cos((i * 0.4) + count) * 80;
      points[i].x = i * ropeLength + Math.cos((i * 0.4) + count) * 10;
    }
  });

}


//ヘッダー
if (document.getElementById('header__box__gradation') != null) {

  // PIXI.オブジェクト生成
  let app = new PIXI.Application({
    width: wSP,
    height: hSP,
    transparent: true,//背景透明化
  });
  document.getElementById('header__box__gradation').appendChild(app.view);

  let count = 0;

  const ropeLength = 90;
  const points = [];

  for (let i = 0; i < 100; i++) {
    points.push(new PIXI.Point(i * ropeLength, 0));
  }

  const strip = new PIXI.SimpleRope(PIXI.Texture.from('https://cdn.shopify.com/s/files/1/0553/5527/7414/files/gradation.png?v=1665543664'), points);

  strip.x = -459;

  const snakeContainer = new PIXI.Container();
  snakeContainer.x = 100;
  snakeContainer.y = 300;

  if (window.matchMedia('(max-width: 1024px)').matches) {
    //スマホ処理
    snakeContainer.x = 100;
    snakeContainer.y = 430;
  }
  
  // snakeContainer.scale.set(800 / 1100);
  app.stage.addChild(snakeContainer);

  snakeContainer.addChild(strip);

  app.ticker.add(() => {
    count += 0.01;

    // make the snake
    for (let i = 0; i < points.length; i++) {
      points[i].y = Math.cos((i * 0.4) + count) * 70;
      points[i].x = i * ropeLength + Math.cos((i * 0.5) + count) * 10;
    }
  });

}